import React from "react";
import HtBannerImage from "../../images/ht-main-banner-image.png";

export default function htMainBanner() {
    return (
        <div className="cs-page-main-banner-section section-gap">
            <div className="cs-banner-image d-flex align-end justify-center">
                <div className="container d-flex flex-wrap align-start justify-center">
                    <img src={HtBannerImage} title="Omnichannel Retail Experience" alt="omnichannel retail platform"/>
                </div>
            </div>
            <div className="cs-main-banner-detail">
                <div className="container">
                    <div className="row d-flex flex-wrap row-banner-title">
                        <div className="col left-bar">
                            <h1>A fresh take on online grocery shopping</h1>
                        </div>
                        <div className="col right-bar">
                            <h3>How we helped Harris Teeter transform <br/>grocery shopping?</h3>
                        </div>
                    </div>
                    <div className="row d-flex flex-wrap align-v-center">
                        <div className="col left-bar">
                            <p>Strategy · Transformation · Engineering · Innovation</p>
                        </div>
                        <div className="col right-bar">
                            {/*<Link className="button button-xsmall button-white-border" to="/contact/">Let's Chat</Link>*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}